export class UrlPathUtils {

    private static escapeRegExp(value: string) {
        return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }

    public static pathStartsWith(path: string, value: string) {
        const result = path.match(new RegExp(`^${this.escapeRegExp(value)}.*`));
        return result ? true : false;
    }

    public static pathIncludesPages(toPath: string, fromPath: string, value: string, pages: Array<string>) {
        if (fromPath == value && pages.includes(toPath)) {
            return true;
        } else {
            return false;
        }
    }

    public static buildUrl(basePath: string, query: Record<string, string | number | null | undefined>): string {
        const params = new URLSearchParams();

        for (const [key, value] of Object.entries(query)) {
            if (value != null) {
            params.set(key, String(value));
            }
        }

        const queryString = params.toString();
        return queryString ? `${basePath}?${queryString}` : basePath;
    }
    
    super() {
        return this;
    }
}
